// Date helpers for the route calendar.
//
// The backend `Route.day_of_the_week` is Monday=0 … Sunday=6, and the Nth-of-month
// resolution mirrors the server filter exactly: nth = (day - 1) // 7 + 1.
// JS `Date.getDay()` is Sunday=0 … Saturday=6, so we convert to the Monday-based index.

const pad = n => String(n).padStart(2, "0");

// Monday-based weekday (0=Mon … 6=Sun) matching backend Route.day_of_the_week.
export const weekdayMon0 = date => (date.getDay() + 6) % 7;

// 1st..5th occurrence of this weekday within its month (matches server-side math).
export const nthOfMonth = date => Math.floor((date.getDate() - 1) / 7) + 1;

// Local YYYY-MM-DD (no timezone shift — the backend runs with USE_TZ=False).
export const ymd = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const firstOfMonth = date => new Date(date.getFullYear(), date.getMonth(), 1);
export const addMonths = (date, n) => new Date(date.getFullYear(), date.getMonth() + n, 1);
export const isSameMonth = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();

const today = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};
export const isToday = date => date.getTime() === today().getTime();

// Six Monday-started weeks (42 cells) covering the given month, so the grid stays rectangular.
export const monthGrid = monthDate => {
  const first = firstOfMonth(monthDate);
  const start = new Date(first);
  start.setDate(first.getDate() - weekdayMon0(first)); // back up to the Monday on/before the 1st
  const weeks = [];
  const cursor = new Date(start);
  for (let w = 0; w < 6; w++) {
    const row = [];
    for (let d = 0; d < 7; d++) {
      row.push(new Date(cursor));
      cursor.setDate(cursor.getDate() + 1);
    }
    weeks.push(row);
  }
  return weeks;
};

// Locale for Intl month/weekday names, keyed by the app's language codes.
const INTL_LOCALE = { uk: "uk", en: "en-GB", hy: "hy", ka: "ka" };
export const localeFor = lang => INTL_LOCALE[lang] || "en-GB";

export const monthLabel = (monthDate, lang) => new Intl.DateTimeFormat(localeFor(lang), { month: "long", year: "numeric" }).format(monthDate);

// Short weekday headers Mon..Sun in the app language.
export const weekdayHeaders = lang => {
  const fmt = new Intl.DateTimeFormat(localeFor(lang), { weekday: "short" });
  // 2024-01-01 is a Monday.
  return Array.from({ length: 7 }, (_, i) => fmt.format(new Date(2024, 0, 1 + i)));
};

export const dayMonthLabel = (date, lang) => new Intl.DateTimeFormat(localeFor(lang), { day: "numeric", month: "short" }).format(date);
